import React from "react";
import ExaminationStatus from "../../../helpers/ExaminationStatus";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

const ExaminationStatusCell = props => (
  <b>
    {props.tReady ? (
      ExaminationStatus.isTransition(props.code) ? (
        <>
          <FontAwesomeIcon icon={faCircleNotch} spin className="mr-2" />
          {props.t(ExaminationStatus.getTranslationByStatus(props.code))}
        </>
      ) : (
        <>{props.t(ExaminationStatus.getTranslationByStatus(props.code))}</>
      )
    ) : (
      <FontAwesomeIcon icon={faCircleNotch} spin className="color-black" />
    )}
  </b>
);

export default withTranslation()(ExaminationStatusCell);
